export const baseUrl = 'https://www.checkout.com/docs';
export const useDocs = () => {
    const getDocumentationLink = (path) => {
        return `${baseUrl}${path}`;
    };
    return {
        getDocumentationLink,
    };
};
